export default __webpack_public_path__ + "static/media/firesofgehenna.a55225f6.png";